import { resolveWidgetConfig } from './signalKValueFormat';
import { sectionColumns } from './dashboardSectionUtils';

/** Section column count from API or editor state (1–3). */
export function clampSectionColumns(columns) {
  const n = parseInt(columns, 10);
  if (!Number.isFinite(n) || n < 1) return 2;
  return Math.min(3, Math.max(1, n));
}

export function sectionGridColumnCount(section) {
  return clampSectionColumns(sectionColumns(section));
}

/** Map stored widget width to a layout key. */
export function resolveWidgetWidthKey(widget) {
  const config = resolveWidgetConfig(widget);
  if (config.layoutWidth) return config.layoutWidth;
  let w = widget?.width ?? config.widthPercent ?? config.width;

  if (w === 2 || w === 'full') return 'full';
  if (w === 'two-thirds' || w === 'twoThirds') return 'two-thirds';
  if (w === 1 || w === 'half' || w === 'third' || w === 'single') return 'third';

  if (typeof w === 'string') {
    const lower = w.toLowerCase();
    if (lower === 'full') return 'full';
    if (lower.includes('two') || lower.includes('double')) return 'two-thirds';
  }
  return 'third';
}

/** How many section grid columns this widget spans. */
export function widgetGridColumnSpan(widget, columns) {
  const cols = clampSectionColumns(columns);
  const widthKey = resolveWidgetWidthKey(widget);

  if (cols === 1) return 1;
  if (cols === 2) {
    return widthKey === 'full' || widthKey === 'two-thirds' ? 2 : 1;
  }
  if (widthKey === 'full') return 3;
  if (widthKey === 'two-thirds') return 2;
  return 1;
}

export function widgetWidthOptionsForSection(columns) {
  const cols = clampSectionColumns(columns);
  if (cols === 1) {
    return [{ value: 'full', label: 'Full width' }];
  }
  if (cols === 2) {
    return [
      { value: 'third', label: 'Half width (1 column)' },
      { value: 'full', label: 'Full width (2 columns)' },
    ];
  }
  return [
    { value: 'third', label: 'Single column (1/3)' },
    { value: 'two-thirds', label: 'Double column (2/3)' },
    { value: 'full', label: 'Full width (3 columns)' },
  ];
}
